import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-group-options",
  "use": "icon-group-options-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-group-options\"><g fill=\"none\" fill-rule=\"evenodd\"><rect width=\"24\" height=\"24\" rx=\"2\" /><g transform=\"rotate(-90 8.5 5.5)\" fill=\"currentColor\" fill-rule=\"nonzero\"><rect width=\"4\" height=\"4\" rx=\"2\" /><rect y=\"7\" width=\"4\" height=\"4\" rx=\"2\" /><rect y=\"14\" width=\"4\" height=\"4\" rx=\"2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol